import { render, staticRenderFns } from "./impuesto.vue?vue&type=template&id=0f806440&"
import script from "./impuesto.vue?vue&type=script&lang=js&"
export * from "./impuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports